import React, { useState, useEffect } from "react";
import logo from "../../../assets/images/logo2.svg";
import "./Login.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LoginSlider from "./LoginSlider";
import img1 from "../../../assets/images/GettingStarted/01.png";
import img2 from "../../../assets/images/GettingStarted/02.png";
import img3 from "../../../assets/images/GettingStarted/03.png";
import img4 from "../../../assets/images/GettingStarted/04.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { CircularProgress } from "@mui/material";
import { sendOtp } from "../../../api/auth";
import Spinner from "../../Spinner";
import useAppContext from "../../context/AppContext";
import CountDownTimer from "./CountDownTimer";

import { getValidLogin } from "../../../utils";

const loginIllustrations = [
  {
    id: 1,
    image: img1,
    title: "A complete solution to take care of all your medical needs!",
  },
  {
    id: 2,
    image: img2,
    title: "Keep track of your medicine intake",
  },
  {
    id: 3,
    image: img3,
    title: "Track and manage your health records",
  },
  {
    id: 4,
    image: img4,
    title: "Get certified Doctor’s appointment in seconds",
  },
];

const initialState = { Otp: new Array(6).fill("") };

const Login = () => {
  const { openSnackbar } = useAppContext();
  const [isResendOtpEnabled, setIsResendOtpEnabled] = useState(false);
  const [activeSlide, setactiveSlide] = useState(0);
  const [otp, setOtp] = useState(initialState.Otp);
  const [loginText, setLoginText] = useState("");
  const [validLogin, setValidLogin] = useState({});
  const [formNumber, setFormNumber] = useState(1);
  const navigate = useNavigate();
  const { verifyOtpWithBackend } = useAuth();
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const handleKeyDown = (element, event) => {
    // Focus Previous Inout On Backspace
    if (
      event.key === "Backspace" &&
      element.value.length === 0 &&
      element.previousSibling
    ) {
      element.previousSibling.focus();
    }
  };
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;
    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    //Focus next input
    if (element.nextSibling && element.value) {
      element.nextSibling.focus();
    }
  };

  // AUTO-VERIFY (mirrors drcfo.frontend Auth.js): once all 6 digits are in —
  // typed, pasted, or auto-filled from the non-prod `otp` echo — submit
  // without a second click.
  useEffect(() => {
    if (formNumber === 2 && otp.every((digit) => digit !== "") && !loading) {
      verifyOtp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  let settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    swipeToSlide: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1200,
    beforeChange: (current, next) => setactiveSlide({ activeSlide: next }),
    // afterChange: (current) => setactiveSlide2({ activeSlide2: current }),
    appendDots: (dots) => (
      <ul
        style={{
          margin: "0",
          padding: "0",
        }}
      >
        {dots}
      </ul>
    ),
    customPaging: (i) => (
      <div
        style={{
          position: "absolute",
          bottom: "0vh",
          width: "0.5rem",
          height: "0.5rem",
          borderRadius: "50%",
          background: `${
            activeSlide.activeSlide === i ? "#194AF5" : "#D9D9D9"
          }`,
        }}
      >
        {/* {i + 1} */}
      </div>
    ),
  };

  async function onSubmitPhoneNumber() {
    setLoading(true);
    const loginPostData = getValidLogin(loginText);
    if (loginPostData) {
      const isOtpSent = await sendOtp(loginPostData);
      if (isOtpSent) {
        openSnackbar({
          severity: "success",
          message: "OTP Sent",
        });
        setValidLogin(loginPostData);
        setFormNumber(2);
        // Dev convenience: backend returns `otp` only in non-prod
        if (isOtpSent?.otp) {
          setOtp(String(isOtpSent.otp).split(""));
        }
      } else {
        // console.log("authenticatedUser", firebaseAuthResponse);
        openSnackbar({
          severity: "error",
          message: "Could not send OTP!",
        });
      }
    } else {
      openSnackbar({
        severity: "error",
        message: "Please enter valid login credentials",
      });
    }
    setLoading(false);
  }

  // console.log("login", location.state?.from?.pathname);
  async function verifyOtp() {
    setLoading(true);
    const OTP = otp.join("");
    const authenticatedUser = await verifyOtpWithBackend({
      ...validLogin,
      otp: OTP,
    });
    if (authenticatedUser) {
      // console.log("verifyOtp", authenticatedUser);
      openSnackbar({
        severity: "success",
        message: "OTP verified successfully",
      });
      if (authenticatedUser?.type === "LOGIN") {
        // Keep the query string: the video consultation link carries the
        // appointment in `?appointmentId=`, and dropping it lands the patient
        // on an empty call page (NABH COP.7.a).
        const from = location.state?.from;
        const returnTo = from?.pathname
          ? `${from.pathname}${from.search || ""}`
          : "/";
        navigate(returnTo, {
          replace: true,
          state: from?.state,
        });
      } else if (authenticatedUser?.type === "SIGNUP") {
        navigate("/createprofile", {
          state: { from: location.state?.from },
        });
      } else {
        console.log("UNEXPECTED RESPONSE FROM BACKEND", authenticatedUser);
      }
    } else {
      openSnackbar({
        severity: "error",
        message: "OTP verification failed!",
      });
    }
    setLoading(false);
  }

  function onClickEditNumber() {
    // console.log("onClickEditNumber");
    setFormNumber(1);
    setOtp(initialState.Otp);
  }

  async function onClickResendOtp() {
    setLoading(true);
    if (validLogin) {
      const isOtpSent = await sendOtp(validLogin);
      if (isOtpSent) {
        setIsResendOtpEnabled(false);
        openSnackbar({
          severity: "success",
          message: "OTP Sent",
        });
        // Dev convenience: backend returns `otp` only in non-prod
        if (isOtpSent?.otp) {
          setOtp(String(isOtpSent.otp).split(""));
        }
      } else {
        openSnackbar({
          severity: "error",
          message: "Could not resend OTP!",
        });
      }
    } else {
      openSnackbar({ severity: "error", message: "Invalid credentials" });
    }
    setLoading(false);
  }

  return (
    <div className="login_screens" id="layout">
      <div id="recaptcha-container" />
      <div className="login_slider_logo" onClick={() => navigate("/")}>
        <img src={logo} alt="logo" />
      </div>
      <h1>Welcome!</h1>
      <Slider {...settings}>
        {loginIllustrations.map((data, id) => (
          <div key={id}>
            <LoginSlider data={data} />
          </div>
        ))}
      </Slider>
      {formNumber === 1 ? (
        <div className="number_input_form">
          <h2>Sign in by entering the information below.</h2>
          <div>
            <div className="login_input_icon">
              <svg
                width="15"
                height="19"
                viewBox="0 0 15 19"
                fill="none"
                className="input_icon_patient"
              >
                <path
                  d="M7.00014 18.8702C6.73773 18.8374 6.47486 18.8081 6.2129 18.7709C5.2328 18.6323 4.30509 18.304 3.43384 17.7965C2.04634 16.9885 0.941127 15.8403 0.101491 14.3788C-0.0209087 14.1652 -0.0340068 13.9745 0.0698749 13.7446C0.830922 12.0606 2.03279 10.9824 3.68948 10.5241C3.82046 10.4878 3.9546 10.4674 4.08649 10.4362C4.34754 10.3746 4.57202 10.455 4.78701 10.6219C5.6429 11.2874 6.59997 11.5848 7.64376 11.5342C8.43687 11.4959 9.20018 11.2839 9.83882 10.7674C10.3167 10.381 10.7769 10.3979 11.2905 10.5553C12.7416 11.0008 13.8365 11.9528 14.6061 13.3707C14.934 13.975 14.9448 13.985 14.5925 14.5695C13.7258 16.0082 12.6003 17.133 11.1893 17.8983C10.1586 18.457 9.0692 18.7748 7.92153 18.8448C7.88449 18.8473 7.84836 18.8607 7.81132 18.8692H7.00014V18.8702Z"
                  fill="#D5D5D5"
                />
                <path
                  d="M7.74666 0.5625C8.1649 0.674238 8.60437 0.729363 8.99776 0.907648C10.4887 1.58553 11.397 2.81266 11.6747 4.57118C11.9832 6.52337 11.1129 8.51331 9.50814 9.46234C7.94585 10.386 6.38943 10.2917 4.93237 9.17431C3.76257 8.27742 3.14651 6.99566 3.11986 5.42635C3.09005 3.68273 3.77432 2.31307 5.08368 1.33474C5.6618 0.902681 6.30948 0.665796 7.00504 0.588324C7.03665 0.584848 7.06692 0.571439 7.09808 0.5625H7.74712L7.74666 0.5625Z"
                  fill="#D5D5D5"
                />
              </svg>
            </div>
            <input
              onChange={(e) => setLoginText(e.target.value)}
              value={loginText}
              className="login_details_input"
              placeholder="Enter Phone Number or Email"
            />
          </div>
          <button
            onClick={onSubmitPhoneNumber}
            className="login_form_inut_cta"
            disabled={loading}
          >
            {loading ? <Spinner /> : "Log In"}
          </button>
        </div>
      ) : formNumber === 2 ? (
        <div className="otp_input_form">
          <h2>
            Enter the One Time Password which has been sent on your number
          </h2>
          <div className="otp_details">
            <div className="d-flex justify-content-between">
              <div>
                <p className="phone_number">{loginText}</p>
                <span className="otp_timer">
                  <svg width="14" height="15" viewBox="0 0 14 15" fill="none">
                    <rect width="16" height="15" fill="url(#pattern0)" />
                    <defs>
                      <pattern
                        id="pattern0"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlinkHref="#image0_1054_162"
                          transform="matrix(0.0104167 0 0 0.0111111 0.03125 0)"
                        />
                      </pattern>
                      <image
                        id="image0_1054_162"
                        width="90"
                        height="90"
                        xlinkHref="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                  <CountDownTimer setIsExpired={setIsResendOtpEnabled} />{" "}
                  <span
                    className={isResendOtpEnabled ? "resend_otp_cta" : ""}
                    onClick={isResendOtpEnabled ? onClickResendOtp : undefined}
                  >
                    Resend OTP
                  </span>
                </span>
              </div>
              <p className="change_num" onClick={onClickEditNumber}>
                Edit Number
              </p>
            </div>
            <div className="otp_box d-flex justify-content-center">
              {otp.map((data, index) => {
                return (
                  <input
                    className="login_otp_field"
                    type="text"
                    name="otp"
                    maxLength="1"
                    key={index}
                    value={data}
                    onChange={(e) => handleChange(e.target, index)}
                    onFocus={(e) => e.target.select()}
                    onKeyDown={(e) => handleKeyDown(e.target, e)}
                  />
                );
              })}
            </div>
          </div>
          <button
            onClick={verifyOtp}
            className="login_form_inut_cta"
            disabled={loading}
          >
            {loading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress sx={{ color: "white" }} size="1.25rem" />
              </div>
            ) : (
              "Log In"
            )}
          </button>
        </div>
      ) : null}

      {/* <div className="login_screen_footer">
        <h6>
          By continuing you about to agree to the{" "}
          <span
            className="hightlighted_text"
            onClick={() => navigate("/termsandcondition")}
          >
            Terms & Conditions
          </span>{" "}
          and{" "}
          <span
            onClick={() => navigate("/privacypolicies")}
            className="hightlighted_text"
          >
            Privacy Policy
          </span>
        </h6>
      </div> */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
        }}
      ></div>
    </div>
  );
};

export default Login;
